var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"map-wrapper",attrs:{"no-gutters":""}},[_c('v-flex',{ref:"map",staticClass:"map"}),(_vm.bubbleEstate)?_c('div',{staticStyle:{"position":"fixed","top":"-10000px"}},[_c('estate-box',{key:_vm.bubbleEstate.id,ref:"bubble",staticClass:"estate-box-map-buble",attrs:{"estate":_vm.bubbleEstate}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }